import AccordionModels from '../utils/AccordionModels.js';

export default class Accordion {
  constructor(element) {
    this.element = element;
    this.panels = Array.from(this.element.querySelectorAll('.panel'));
    this.canvas = this.element.querySelector('.accordion__webgl');
    this.models = null;

    this.init();
  }

  init() {
    // Modèles 3D des onglets (un seul canvas pour tout l'accordéon)
    if (this.canvas) {
      this.models = new AccordionModels({
        element: this.element,
        canvas: this.canvas,
        panels: this.panels,
      });

      // Un glissement sur le modèle ne doit ni suivre le lien ni lancer le glisser-déposer du lien
      this.element.addEventListener(
        'click',
        (event) => {
          if (this.models.justDragged) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true,
      );
      this.element.addEventListener('dragstart', (event) =>
        event.preventDefault(),
      );
    }

    this.panels.forEach((panel) => {
      // Mouse: open when hovering anywhere on the panel
      panel.addEventListener('mouseenter', () => this.open(panel));

      // Keyboard: links are focusable, so open on focus too
      panel.addEventListener('focus', () => this.open(panel));

      // Click: navigate only if the panel is already open.
      // On touch screens (no hover), the first tap opens it
      // and the second tap follows the link.
      panel.addEventListener('click', (event) => {
        if (!panel.classList.contains('active')) {
          event.preventDefault();
          this.open(panel);
        }
      });
    });
  }

  open(activePanel) {
    // Pendant qu'on fait tourner un modèle, l'onglet ne change pas
    if (this.models && this.models.isDragging) return;

    this.panels.forEach((panel) => {
      panel.classList.toggle('active', panel === activePanel);
    });
  }
}
